import { RestChatService } from '@repo/network'

export const subscribeNativePushRemote = async (token: string) => {
  try {
    RestChatService.notificationPushSubscribe(token)
  } catch (e) {
    console.error(e)
  }
}

export const unsubscribeNativePushRemote = async () => {
  RestChatService.notificationPushUnsubscribe()
}
